
<template>
  <div class="white-container marginTop">
    <p class="f500 mb10">上传轮播图</p>
    <template v-for="(item, cindex) in contents">
      <UploadImg v-if="item.type === 'image'" :key="cindex" :index="cindex" :img-info="item.content" @uploadImg="handleUploadImgInfo" @del="delComponent" />
      <UploadVideo v-if="item.type === 'video'" :key="cindex" :index="cindex" :video-info="item.content" @uploadVideo="handleUploadVideoInfo" @del="delComponent" />
    </template>
    <div class="add-btn-box">
      <el-button class="add-btn" icon="el-icon-plus" @click="addComponent('image')">添加图片</el-button>
      <el-button class="add-btn" icon="el-icon-plus" @click="addComponent('video')">添加视频</el-button>
      <el-button class="add-btn" icon="el-icon-minus" @click="delSwiper">删除</el-button>
    </div>
  </div>
</template>
<script>
import UploadImg from "./uploadImg.vue";
import UploadVideo from "./uploadVideo.vue";
export default {
  name: 'UploadSwiper',
  components: { UploadImg, UploadVideo },
  props: {
    contents: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return { };
  },
  methods: {
    addComponent(type) {
      const itemObj = {
        type,
        content: { sourceUrl: '', jumpLink: '', sensorsData: { btnName: '', moduleName: '' }, subscribeId: '' },
      };
      if (type === 'video') {
        itemObj.content.cloudVideoId = null;
        itemObj.content.coverImageUrl = '';
      }
      this.contents.push(itemObj);
      this.updateCarousel();
    },
    handleUploadImgInfo(data) {
      this.contents[data.index].content = data.imgInfo;
      this.updateCarousel();
    },
    handleUploadVideoInfo(data) {
      this.contents[data.index].content = data.videoInfo;
      this.updateCarousel();
    },
    delComponent(index) {
      this.contents.splice(index, 1);
      this.updateCarousel();
    },
    updateCarousel() {
      this.$emit('update', { contents: this.contents, index: this.index });
    },
    delSwiper() {
      this.$emit('del', this.index);
    },
  },
};
</script>

<style lang="less" scoped>
  .marginTop {
    margin-top: 30px;
  }
  .f500{
    font-weight: 500;
  }
  .mb10{
    margin-bottom: -30px;
  }
  .add-btn-box{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:35px;
  }
  .add-btn{
    width: 150px;
    height: 34px;
    border: 1px dashed #9B9B9B;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }
</style>
